import * as React from "react";
import Timestamp from "./Timestamp";
import { TogglesClass } from "./Toggles";

interface TLEDHProps {
  Toggles: TogglesClass;
  Object: any;
  Data: Array<any>;
  Squished: boolean;
  ID: number;
  SquishMe: (ident: number) => void;
}

export default function TLEntryDatumHistory(props: TLEDHProps) {
  return (
    <div className="DatumEntry">
      <div className="Icon">&#128218;</div>
      <div className="Label">Data Entry</div>
      <Timestamp
        Timestamp={props.Object["Timestamp"]}
        Toggles={props.Toggles}
      />
      {props.Squished === undefined || props.Squished === true ? (
        <React.Fragment>
          <b title={props.Object["RelevantUser"]}>
            {props.Object["RelevantUserLabel"]}
          </b>{" "}
          set this data:
          <button
            className={"SquishButton Squished"}
            onClick={() => props.SquishMe(props.ID)}
          >
            <React.Fragment>&#43;</React.Fragment>
          </button>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <b title={props.Object["RelevantUser"]}>
            {props.Object["RelevantUserLabel"]}
          </b>{" "}
          set this data:
          <button
            className={"SquishButton"}
            onClick={() => props.SquishMe(props.ID)}
          >
            <React.Fragment>&#8722;</React.Fragment>
          </button>
          <br />
          <div className="FieldWrap">
            <div className="Fields">
              {props.Data !== undefined
                ? props.Data.map(
                    (
                      dt: {
                        FieldName:
                          | string
                          | number
                          | boolean
                          | React.ReactElement<
                              any,
                              string | React.JSXElementConstructor<any>
                            >
                          | React.ReactNode
                          | React.ReactPortal
                          | null
                          | undefined;
                        FieldValue:
                          | string
                          | number
                          | boolean
                          | React.ReactElement<
                              any,
                              string | React.JSXElementConstructor<any>
                            >
                          | React.ReactNode
                          | React.ReactPortal
                          | null
                          | undefined;
                      },
                      j: Number,
                    ) => (
                      <div
                        className="FieldRow"
                        key={"subdatum_" + j.toString()}
                      >
                        <div className="FieldName">{dt.FieldName}</div>
                        <div className="FieldValue">{dt.FieldValue}</div>
                      </div>
                    ),
                  )
                : ""}
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
}
